import { AnimatedText } from '@/components/shared/animated-text';
import { useProfileShow } from '@/data/account/profile';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';

export const WelcomeStep = ({ id }: QuestionProps) => {
  const { currentQuestionId, goNext } = useProfileQuiz();
  const { profile } = useProfileShow();

  const isActive = currentQuestionId === id;

  const text = `👋 Olá, ${profile?.first_name}!\n\nBoas-vindas à Galena, a sua plataforma de desenvolvimento de habilidades. Aqui você encontra todas as ferramentas, cursos e conteúdos para desenvolver as competências certas para os seus próximos passos na carreira.\n\nPara personalizar sua experiência de forma inteligente e com base nos seus objetivos, interesses e conhecimentos atuais, vou fazer algumas perguntas rápidas. Vamos nessa?`;

  return <AnimatedText text={text} isActive={isActive} onEnd={goNext} />;
};
